import React from 'react';
import { withRouter, Switch, Route, BrowserRouter as Router, Redirect } from 'react-router-dom';
import { LayoutRoute, MainLayout } from 'components/Layout';

import Authentication from 'core/frameworks/Authentication';

import Login from './pages/Login';
import Register from './pages/Registro';
import Formulario1 from 'pages/Formulario1';
import Formulario2 from 'pages/Formulario2';


// paginas
import Inicio from 'pages/Inicio';
import GestorBlog from './pages/GestorBlog';
import GestorCiclos from './pages/GestorCiclos';
import GestorAnuncios from './pages/GestorAnuncios';
import GestorCalificaciones from './pages/GestorCalificaciones';
import GestorMaterial from './pages/GestorMaterial';
import Postulaciones from './pages/Postulaciones';
import GestorUsuarios from './pages/GestorUsuarios';
import GestorTipoUsuario from './pages/GestorTipoUsuario';
import GestorEstudiantes from './pages/GestorEstudiantes';
import GestorGaleria from './pages/GestorGaleria';
import EstudianteAnuncios from './pages/EstudianteAnuncios';
import EstudianteMaterial from './pages/EstudianteMaterial';
import EstudianteCalificaciones from './pages/EstudianteCalificaciones';
import ConfiguracionUsuario from './pages/ConfiguracionUsuario';



const Auth = new Authentication();

class SimpleRoute extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loaded: false,
			isAuthenticated: false,
			userType: false,
			admin: false,
			user:{}
		}

	};
	
 	componentDidMount() {
		this.autenticar();	
	};
	

	autenticar = async () => {
		try{
			let datos = await Auth.getCurrentUser();
			this.setState({user:datos, loaded: true, isAuthenticated: true }) 
		}catch(e){
			this.props.history.push('/');
		}

	}
	
  render() {
    	
		const { loaded , isAuthenticated, user } = this.state;
		const { component: Component, type, ...rest } = this.props;
		
		if(!loaded) {
			return null;
		} else if(isAuthenticated) {
			return <LayoutRoute {...rest} layout={MainLayout} component={Component} user={user}/>
		} else {
			return <Redirect to={{ pathname: "/" }} />;
		}
  };
};

SimpleRoute = withRouter(SimpleRoute);





class Routes extends React.Component {

	constructor(){
		super();
		this.state = {
			user:''
		}
	}

	dataUser = (user) => {
		this.setState({user: user})	
	}

	render(){
		const {user} = this.state; 
	return (
		<Router>
			<Switch>

				{/* Rutas no protegidas */}
				<Route
				exact path="/"
				render={(props) => <Login {...props} dataUser={this.dataUser} />}
				/>
				{/* <Route exact path="/" component={Login} /> */}
				<Route exact path="/registro" component={Register} />

				{/* Rutas protegidas */}
				<SimpleRoute exact  path="/inicio" component={Inicio} user={user}/>
				<SimpleRoute exact  path="/formulario1" component={Formulario1} />
				<SimpleRoute exact  path="/formulario2" component={Formulario2} />
				{/* paginas */}
				<SimpleRoute exact  path="/gestorBlog" component={GestorBlog} />
				<SimpleRoute exact  path="/gestorGaleria" component={GestorGaleria} />
				<SimpleRoute exact  path="/gestorCiclos" component={GestorCiclos} />
				<SimpleRoute exact  path="/gestorAnuncios" component={GestorAnuncios} />
				<SimpleRoute exact  path="/gestorCalificaciones" component={GestorCalificaciones} />
				<SimpleRoute exact  path="/gestorMaterial" component={GestorMaterial} />
				<SimpleRoute exact  path="/gestorUsuarios" component={GestorUsuarios} />
				<SimpleRoute exact  path="/gestorTipoUsuario" component={GestorTipoUsuario} />
				<SimpleRoute exact  path="/gestorEstudiantes" component={GestorEstudiantes} />
				<SimpleRoute exact  path="/postulaciones" component={Postulaciones} />
				<SimpleRoute exact  path="/estudianteAnuncios" component={EstudianteAnuncios} />
				<SimpleRoute exact  path="/estudianteMaterial" component={EstudianteMaterial} />
				<SimpleRoute exact  path="/estudianteCalificaciones" component={EstudianteCalificaciones} />
				<SimpleRoute exact  path="/configuracionUsuario" component={ConfiguracionUsuario} />



			</Switch>
		</Router>
	);
}
}
export default Routes;